import { connect } from 'react-redux';

import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { GlobalState } from 'ha/types/store';
import { getCurrentSearchAlert } from '../../selectors';
import SearchAlertConfirmation from '../../components/SearchAlerts/SearchAlertConfirmation';

export default connect((state: GlobalState) => ({
  hasAlert: Boolean(getCurrentSearchAlert(state)),
  isAuthenticated: getIsAuthenticated(state),
}))(SearchAlertConfirmation);
